export const HTML_TAG_REGEX = /<\/?[^>]+(>|$)/g;
